module.exports = __webpack_public_path__ + "img/reset-icon.6b216ace.svg";